import { Injectable } from '@angular/core';
import { API_ENDPOINTS } from 'app/core/constants/api-endpoints.constant';
import { ApiService } from 'app/shared/constant/api-service/api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class Jc3feedbackService {
    constructor(private _apiService: ApiService) {}

    fetchFeedbackList(): Observable<any> {
        return this._apiService.get(API_ENDPOINTS.FETCH_FEEDBACK);
    }

    exportFeedback(): Observable<any> {
        return this._apiService.post(
            API_ENDPOINTS.EXPORT_FEEDBACK,
            {},
            { responseType: 'blob', observe: 'response' }
        );
    }
}
